import React, {useEffect, useState} from 'react';
import {getFilterAssetsLogData} from '../../services/asset.service';
import Box from '@mui/material/Box';
import {DataGrid, GridOverlay} from '@mui/x-data-grid';
import * as CryptoJS from "crypto-js";
import FromFieldDate from "../../atoms/FromFieldDate";
import FromFieldText from "../../atoms/FromFieldText";
import {FormControl, InputLabel, MenuItem, Pagination, Select} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

function getFormatedDate(dateString) {
    if (dateString != null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

const columns = [
    {"field": "sl_no", "hideable": true, "hide": false, "editable": false, "headerName": "Sl No", "width": 50},
    {"field": "tag", "hideable": true, "hide": false, "editable": false, "headerName": "TAG", "width": 250},
    {"field": "epc_no", "hideable": true, "hide": false, "editable": false, "headerName": "EPC No", "width": 250},
    {
        "field": "created_at", "editable": true, "hide": false, "headerName": "Date", "width": 150,
        renderCell: (params) => (
            <p>{getFormatedDate(params.row.created_at)}</p>
        )
    },
    {"field": "status", "hideable": true, "hide": false, "editable": false, "headerName": "Status", "width": 100},
    {"field": "sl_no3", "hideable": true, "hide": false, "editable": false, "headerName": "Time Out", "width": 100},
    {"field": "location", "hideable": true, "hide": false, "editable": false, "headerName": "Location", "width": 150},
    {
        "field": "rfid_reader_name",
        "hideable": true,
        "hide": false,
        "editable": false,
        "headerName": "Reader Name",
        "width": 150
    },
];

const CustomLoader = () => (
    <GridOverlay>
        <CircularProgress color="primary" size={30}/>
    </GridOverlay>
);

function SingleAssetLog() {
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [searchTagEpc, setSearchTagEpc] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [page, setPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const calculateOffset = (page, pageSize) => (page - 1) * pageSize;
    const offset = calculateOffset(page, pageSize);
    const getTagInfo = async (isSearch = false) => {
        setLoading(true);
        let obj = {
            offset: offset,
            pageSize: pageSize,
            startDate: startDate ? getFormatedDate(startDate) : '',
            endDate: endDate ? getFormatedDate(endDate) : '',
            searchTagEpc: isSearch ? searchTagEpc || '' : '', // Only include searchTagEpc for search
        };

        // Encrypt data
        let EncryptData = CryptoJS.AES.encrypt(
            JSON.stringify({
                param_data: obj,
                authToken: sessionStorage.getItem('LoggedInToken'),
            }),
            process.env.REACT_APP_ENCRYPT_SECRET_KEY
        ).toString();

        let oData = {token: EncryptData};

        try {
            const res = await getFilterAssetsLogData(oData);
            if (res?.data?.data?.length) {
                setItems(res.data.data);
                setTotalItems(res.data.total || 0);
            } else {
                setItems('');
            }

        } catch (error) {
            console.error('Error fetching asset log data:', error);
            setItems([]); // Clear items on error
        } finally {
            setLoading(false);
        }
    };

    // Fetch default data on component mount
    useEffect(() => {
        getTagInfo(false); // Fetch default data (no searchTagEpc filter)
    }, [page, pageSize]);

    // Handle search button click
    const handleSearch = () => {
        getTagInfo(true); // Fetch filtered data with searchTagEpc
    };
    const handlePageSizeChange = (value) => {
        setPageSize(value);
        setPage(1);
    };
    const handlePageChange = (event, value) => {
        setPage(value);
    };
    const totalPages = Math.ceil(totalItems / pageSize);

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h5>Single Asset Log</h5>
                </div>
            </div>

            <div className="row mb-2 mt-4">
                <div className="col-6">
                    <FromFieldText
                        label="Search TAG/EPC No"
                        placeholder="Enter TAG/EPC No"
                        inputValue={searchTagEpc}
                        setInputValue={setSearchTagEpc}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-4">
                    <FromFieldDate
                        label="Start Date"
                        placeholder="Select Start Date"
                        inputValue={startDate}
                        setInputValue={setStartDate}
                    />
                </div>
                <div className="col-4">
                    <FromFieldDate
                        label="End Date"
                        placeholder="Select End Date"
                        inputValue={endDate}
                        setInputValue={setEndDate}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-4 text-center mt-2 mb-3">
                    <button onClick={handleSearch} className="btn btn-info btn-md">
                        <i className="bi bi-search"></i> Search
                    </button>
                </div>
            </div>

            <div className="row">

                <Box sx={{height: 500, width: '100%'}}>
                    {loading ? (
                        <div className="text-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <DataGrid
                            rows={items}
                            getRowId={(row) => row.sl_no}
                            columns={columns}
                            autoHeight
                            components={{
                                LoadingOverlay: CustomLoader,
                                Pagination: () => (
                                    <Box sx={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        mt: 2
                                    }}>
                                        <Box sx={{mr: 4}}>
                                            Showing {items.length} records out of {totalItems}
                                        </Box>
                                        <FormControl variant="outlined" sx={{minWidth: 120}}>
                                            <InputLabel>Rows per page</InputLabel>
                                            <Select
                                                value={pageSize}
                                                onChange={(event) => handlePageSizeChange(Number(event.target.value))}
                                                label="Rows per page"
                                            >
                                                {[10, 25, 50, 100, 200, 500].map((size) => (
                                                    <MenuItem key={size} value={size}>
                                                        {size}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>


                                        <Pagination
                                            count={totalPages}
                                            page={page}
                                            onChange={handlePageChange}
                                            variant="outlined"
                                            shape="rounded"
                                        />

                                    </Box>
                                ),
                            }}
                            loading={loading}
                        />
                    )}
                </Box>
            </div>
            <div id="print_qr"></div>
        </div>
    )
}

export default SingleAssetLog;
